import { Component, Input, OnInit } from '@angular/core';
import { ISolicitudPersonaModel } from 'src/app/models/interfaces/solicitud/ISolicitudPersonaModel';

@Component({
  selector: 'app-persona-form',
  templateUrl: './persona-form.component.html',
  styleUrls: ['./persona-form.component.css']
})
export class PersonaFormComponent implements OnInit {
  @Input() persona!: ISolicitudPersonaModel;
  @Input() disabled: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }
}
